module.exports = __webpack_public_path__ + "static/partner4-b39d98c76e367d05a35ce0cecb4e5e93.png";